import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import ImageListForSegment from './ImageListForSegment';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';

const styles = theme => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: 200,
    },
    menu: {
        width: 200,
    },
});

class EditForm extends React.Component {
    state = {
        name: 'Cat in the Hat',
        age: '',
        multiline: 'Controlled',
        currency: 'EUR',
    };

    handleChange = name => event => {
        this.setState({
            [name]: event.target.value,
        });
    };
    
    onFileLoad = (e, file) => console.log(e.target.result, file.name);

    render() {
        const { classes } = this.props;

        return (
            <form className={classes.container} noValidate autoComplete="off">
                <List>
                    <ListItem>
                    <TextField
                            id="full-width"
                            label="Hero headline"
                            InputLabelProps={{shrink: true}}
                            placeholder="enter hero title"
                            helperText="must be not more than 256 chars"
                            margin="normal"
                        />
                    </ListItem>
                    <ListItem>
                        <TextField
                            id="multiline-static"
                            label="Hero text"
                            multiline
                            rows="4"
                            margin="normal"
                            fullWidth
                        />
                    </ListItem>
                    <ListItem>
                        <TextField
                            id="full-width"
                            label="Call To Action"
                            InputLabelProps={{shrink: true}}
                            placeholder="enter button label here"
                            helperText="must be not more than 100 chars"
                            margin="normal"
                        />
                    </ListItem>
                    <li><Divider/></li>
                    
                    <ListItem>
                        The following images are effective influencers for the 'urban hipster' profile
                    </ListItem>
                    <ListItem>
                        <ImageListForSegment/>
                    </ListItem>
                    <ListItem>
                        
                    </ListItem>
                </List>
    </form>
        );
    }
}

EditForm.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(EditForm);


// WEBPACK FOOTER //
// ./src/components/personalization/EditForm.js